module.exports = __webpack_public_path__ + "static/media/farmers-market.9fdfde4d.png";